import { createClient } from "contentful";

const client = createClient({
    space: '732zop3mvuem',
    accessToken: 'AvKfBR1wKRruTVsnmAlpo8WhJpFmJXZ14bYKBI49kr4',
})

export default client;